module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"cradle\"-in-los-angeles-california-01656d5c0efde45b8cd9e4040386ff3a.png";